import { clearBrowserCookies, clearWebStorage } from '@/lib/storage/browserStorage';
import { NEXT_PUBLIC_SNAPCHAT_DISABLED, NEXT_PUBLIC_SNAPCHAT_PIXEL_ID } from '@/lib/env';
import logger from './logger';

// Snapchat first-party cookies (_scid, _scid_r, _sctr, sc_at, sc_*) and pixel storage keys (u_sclid*, u_scsid*). Matched by prefix so withdraw teardown clears the full set, kept disjoint from other services' key-sets (GTM _ga*/_gcl*, Amplitude AMP_*, Hotjar _hj*).
const SNAPCHAT_KEY_PREFIXES = ['sc_', '_scid', '_sctr', 'u_sclid', 'u_scsid'];

let enabled = false;

export const isSnapchatConfigured = (): boolean =>
  !NEXT_PUBLIC_SNAPCHAT_DISABLED && Boolean(NEXT_PUBLIC_SNAPCHAT_PIXEL_ID?.trim());

export const isSnapchatEnabled = (): boolean => enabled && isSnapchatConfigured();

const isSnapchatKey = (key: string): boolean =>
  SNAPCHAT_KEY_PREFIXES.some((prefix) => key.startsWith(prefix));

const clearSnapchatStorage = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  const cookiesRemoved = clearBrowserCookies(isSnapchatKey);
  const localRemoved = clearWebStorage(() => window.localStorage, isSnapchatKey);
  const sessionRemoved = clearWebStorage(() => window.sessionStorage, isSnapchatKey);

  logger.debug('Cleared Snapchat storage', { cookiesRemoved, localRemoved, sessionRemoved });
};

export const enableSnapchat = (): boolean => {
  if (typeof window === 'undefined' || !isSnapchatConfigured()) {
    enabled = false;
    return false;
  }

  enabled = true;
  return true;
};

export const disableSnapchat = (): void => {
  enabled = false;
  // Mirrors Convert/Hotjar teardown: storage is cleared and event calls are gated off.
  // A loaded vendor runtime may persist until a full page reload.
  logger.debug('Snapchat disabled: stopping tracking calls and clearing storage');
  clearSnapchatStorage();
};
